import { Injectable } from "@angular/core";
import { CurrentCaseService } from "@modules/common/services/current-case.service";
import { CurrentEnvironmentService } from '@modules/common/services/current-environment.service';
import { BehaviorSubject, Observable } from "rxjs";

/** 
 * Service to get the url of the homepage
 */
@Injectable({
    providedIn: 'root'
})
export class HomeUrlService {
    constructor(
		private _currentCaseService: CurrentCaseService,
		private _currentEnvironmentService: CurrentEnvironmentService
    ) {
		this._currentCaseService.caseChanged.subscribe(() => this.updateUrl());
		this._currentEnvironmentService.environmentChanged.subscribe(() => this.updateUrl());
    }

	private _subject = new BehaviorSubject<string>('');

	private updateUrl(): void {
		let newUrl = '';
		if (this._currentEnvironmentService.getCurrentEnvironmentName())
			newUrl += '/' + this._currentEnvironmentService.getCurrentEnvironmentName();
		if (this._currentCaseService.getCurrentCaseName())
			newUrl += '/' + this._currentCaseService.getCurrentCaseName();
		newUrl += '/Dashboards';

		if (newUrl !== this._subject.getValue()) {
			this._subject.next(newUrl);
		}
	}

    public get urlChanged(): Observable<string> {
        return this._subject;
    }

    public getHomeUrl(): string {
        return this._subject.getValue();
    }
}
